import { testimonials } from "@/mocks/home";

export default function Trust() {
  return (
    <section className="py-16 md:py-20 px-4 md:px-8 lg:px-14 bg-background-50">
      <div className="max-w-[1400px] mx-auto">
        <div className="flex flex-col lg:flex-row gap-10 lg:gap-14">
          <div className="w-full lg:w-[60%]">
            <div className="flex items-center gap-2 mb-8">
              <span className="w-2 h-2 rounded-full bg-primary-500"></span>
              <span className="text-xs font-semibold text-foreground-500 uppercase tracking-wider">
                Comunidade
              </span>
            </div>

            <div className="space-y-10">
              {testimonials.map((testimonial) => (
                <div key={testimonial.name}>
                  <p className="font-heading text-xl md:text-2xl italic text-foreground-800 leading-relaxed max-w-lg">
                    &ldquo;{testimonial.text}&rdquo;
                  </p>
                  <div className="flex items-center gap-3 mt-4">
                    <span className="text-sm font-semibold text-foreground-900">{testimonial.name}</span>
                    <div className="flex items-center gap-0.5">
                      {Array.from({ length: testimonial.rating }).map((_, i) => (
                        <i key={i} className="ri-star-fill text-xs text-accent-500"></i>
                      ))}
                    </div>
                    <span className="text-xs text-primary-600 font-medium flex items-center gap-1">
                      <i className="ri-shield-check-line"></i>
                      Verified Buyer
                    </span>
                  </div>
                  <p className="text-xs text-foreground-400 mt-1">{testimonial.location}</p>
                </div>
              ))}
            </div>

            <div className="flex items-center gap-6 mt-10 pt-8">
              <div className="text-center">
                <p className="font-heading text-2xl md:text-3xl font-bold text-primary-600">10.000+</p>
                <p className="text-xs text-foreground-500 mt-1">Usuários ativos</p>
              </div>
              <div className="w-px h-10 bg-background-300"></div>
              <div className="text-center">
                <p className="font-heading text-2xl md:text-3xl font-bold text-primary-600">98%</p>
                <p className="text-xs text-foreground-500 mt-1">Aprovação QC</p>
              </div>
              <div className="w-px h-10 bg-background-300"></div>
              <div className="text-center">
                <p className="font-heading text-2xl md:text-3xl font-bold text-primary-600">50+</p>
                <p className="text-xs text-foreground-500 mt-1">Países atendidos</p>
              </div>
            </div>
          </div>

          <div className="w-full lg:w-[40%]">
            <div className="rounded-3xl overflow-hidden h-[400px] md:h-[500px]">
              <img
                src="https://readdy.ai/api/search-image?query=A%20happy%20young%20person%20with%20warm%20Mediterranean%20complexion%20holding%20a%20freshly%20opened%20shipping%20box%20with%20tissue%20paper%2C%20genuine%20smile%20looking%20down%20at%20the%20package%20contents%2C%20warm%20golden%20hour%20light%20from%20the%20side%2C%20authentic%20lifestyle%20portrait%20photography%20with%20candid%20joyful%20emotion%20and%20natural%20setting&width=560&height=700&seq=trust-portrait-v02&orientation=portrait"
                alt="Comprador verificado CSSBuy Spreadsheet"
                title="Comunidade CSSBuy Spreadsheet"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}